import type { InventoryVehicle } from '@carvana/merch-contracts';
import {
  defaultLoadableState,
  type LoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import React, { createContext, useMemo } from 'react';

type FavoritesContextType = {
  favoriteVehiclesFromSearch: LoadableState<InventoryVehicle[]>;
};

export const defaultContext: FavoritesContextType = {
  favoriteVehiclesFromSearch: defaultLoadableState<InventoryVehicle[]>([])
};

const FavoritesContext = createContext<FavoritesContextType>(defaultContext);

export function FavoritesContextProvider({
  children
}: React.PropsWithChildren) {
  const favoriteVehiclesFromSearch = useLoadableState<InventoryVehicle[]>([]);

  const value = useMemo<FavoritesContextType>(
    () => ({
      favoriteVehiclesFromSearch
    }),
    [favoriteVehiclesFromSearch]
  );

  return (
    <FavoritesContext.Provider value={value}>
      {children}
    </FavoritesContext.Provider>
  );
}

FavoritesContextProvider.displayName = 'FavoritesContextProvider';

export default FavoritesContext;
